import React, { forwardRef } from "react"
import classNames from "classnames"

import "./FormInput.sass"

const FormInput = forwardRef(
  ({ className, label, name, isLong, maxLength = 255, ...rest }, ref) => {
    const formInputClassName = classNames({
      FormInput: true,
      [className]: !!className,
    })

    return (
      <div className="FormField">
        {label && (
          <label className="FormLabel" htmlFor={name}>
            {label}
          </label>
        )}
        {isLong ? (
          <textarea
            className={formInputClassName}
            name={name}
            ref={ref}
            rows={3}
            maxLength={maxLength}
            {...rest}
          />
        ) : (
          <input
            className={formInputClassName}
            name={name}
            ref={ref}
            maxLength={maxLength}
            {...rest}
          />
        )}
      </div>
    )
  },
)

export default FormInput
